import { styled } from '@ori-ui/mui';

import { IconWrap as IconWrapComponent } from '../Thanks/styles';

export const IconWrap = styled(IconWrapComponent)(({ theme }) => ({
  color: theme.palette.error.main,
}));
